module.exports = __webpack_public_path__ + "static/media/fanCleaning.d68e40f1.png";